import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-motivated-to-help-customers-stay-healthy-confident', 
  standalone:true,
  imports: [CommonModule],
  templateUrl: './motivated-to-help-customers-stay-healthy-confident.html',
  styleUrl: './motivated-to-help-customers-stay-healthy-confident.css',
})
export class MotivatedToHelpCustomersStayHealthyConfident {

}
